var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { Button } from './../../index';

var AlertBoxConfirm = function AlertBoxConfirm(_ref) {
  var show = _ref.show,
      handleClose = _ref.handleClose,
      handleOk = _ref.handleOk,
      body = _ref.body,
      title = _ref.title,
      okBtnText = _ref.okBtnText,
      cancelBtnText = _ref.cancelBtnText,
      variant = _ref.variant,
      btnDisable = _ref.btnDisable,
      rest = _objectWithoutProperties(_ref, ['show', 'handleClose', 'handleOk', 'body', 'title', 'okBtnText', 'cancelBtnText', 'variant', 'btnDisable']);

  return React.createElement(
    Modal,
    _extends({ className: 'd-flex', show: show, onHide: handleClose }, rest),
    React.createElement(
      Modal.Header,
      { closeButton: true },
      React.createElement(
        Modal.Title,
        { className: 'text-' + variant },
        title
      )
    ),
    React.createElement(
      Modal.Body,
      null,
      body
    ),
    React.createElement(
      Modal.Footer,
      { className: 'border-0' },
      React.createElement(
        Button,
        { variant: variant, onClick: handleOk, disabled: btnDisable },
        okBtnText
      ),
      React.createElement(
        Button,
        { variant: 'secondary', onClick: handleClose, disabled: btnDisable },
        cancelBtnText
      )
    )
  );
};
AlertBoxConfirm.defaultProps = {

  okBtnText: "Confirm",
  cancelBtnText: "Cancel",
  handleOk: function handleOk() {},
  variant: "primary",
  btnDisable: false
};
AlertBoxConfirm.propTypes = process.env.NODE_ENV !== "production" ? _extends({
  /**
   * Alert should display or not
   */
  show: PropTypes.bool.isRequired,
  /**
   * Callback to tigger on alert close 
   */
  handleClose: PropTypes.func.isRequired,
  /**
   * Callback to trigger on alter ok button click
   */
  handleOk: PropTypes.func.isRequired,
  /**
   * Ok button text
   */
  okBtnText: PropTypes.string,
  /**
   * Cancel button text
   */
  cancelBtnText: PropTypes.string,
  /**
   * Alert body
   */
  body: PropTypes.string.isRequired,
  /**
   * Alert title
   */
  title: PropTypes.string,
  /**
   * Alert color variant (type)
   */
  variant: PropTypes.oneOf(['primary', 'success', 'danger', 'warning', 'info']),
  /**
   * Disable action buttons
   */
  btnDisable: PropTypes.bool
}, Modal.propTypes) : {};
export default AlertBoxConfirm;